import API from "../utils/api";

export const ACTION_TYPES = {
    GIFTCARD_CREATE: 'GIFTCARD_CREATE',
    GIFTCARD_UPDATE: 'GIFTCARD_UPDATE',
    GIFTCARD_DELETE: 'GIFTCARD_DELETE',
    GIFTCARD_FETCH: 'GIFTCARD_FETCH',
    GIFTCARD_FETCH_ALL: 'GIFTCARD_FETCH_ALL',
    GIFTCARD_PAGINATION: 'GIFTCARD_PAGINATION'
}

export const fetchAll = () => dispatch => {
    API.giftcard().fetchAll()
        .then(res => {
       
            dispatch({
                type: ACTION_TYPES.GIFTCARD_FETCH_ALL,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const Pagination = (page = 1, limit = 5, title = "") => dispatch => {

    API.giftcard().fetchPagination(page, Math.abs(limit), title)
        .then(res =>{
           console.log('122',res)
            dispatch({
                type: ACTION_TYPES.GIFTCARD_PAGINATION,
                payload: res.data
            })
        })
        .catch(err => console.log(err))
}

export const fetchById = (id, onSuccess) => dispatch => {
    API.giftcard().fetchById(id)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.GIFTCARD_FETCH,
                payload: res.data
            })
            onSuccess(res.data)
        })
        .catch(err => console.log(err))
}

export const create = (input, onSuccess) => dispatch => {
    API.giftcard().create(input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.GIFTCARD_CREATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const update = (id, input, onSuccess) => dispatch => {
  
    API.giftcard().update(id, input)
        .then(res =>{
            dispatch({
                type: ACTION_TYPES.GIFTCARD_UPDATE,
                payload: res.data
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}

export const Delete = (id, onSuccess) => dispatch => {
    API.giftcard().delete(id)
        .then(res =>{
           
            dispatch({
                type: ACTION_TYPES.GIFTCARD_DELETE,
                payload: res.data.id
            })
            onSuccess()
        })
        .catch(err => console.log(err))
}